export default __webpack_public_path__ + "static/media/aroma.d1518744.svg";